import { createContext, useContext, useRef, useState } from 'react';

import { ListboxContextData, ListboxProviderProps } from './ListboxTypes';

export const ListboxContext = createContext<ListboxContextData>({
  selected: [],
  mode: 'simple',
  parentCanBeChecked: true,
  setSelected: () => {},
});

export function ListboxProvider({
  children,
  mode,
  parentCanBeChecked,
  onChange,
  selected: controlledSelected,
  onClose,
}: ListboxProviderProps) {
  const [internalSelected, setInternalSelected] = useState<string[]>([]);
  const { current: isControlled } = useRef(controlledSelected !== undefined);
  const selected =
    isControlled && controlledSelected !== undefined ? controlledSelected : internalSelected;

  const setSelected = (callback: any) => {
    let value;
    if (typeof callback === 'function') {
      value = callback(selected);
    } else {
      value = callback;
    }
    setInternalSelected(value);

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <ListboxContext.Provider
      value={{
        selected,
        setSelected,
        mode,
        parentCanBeChecked,
        onClose,
      }}
    >
      {children}
    </ListboxContext.Provider>
  );
}

export function useListbox() {
  return useContext(ListboxContext);
}
